module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-33.1992f8e6.png";